import { Injectable } from '@angular/core';
import { configURI } from '../../../shared/apiUrlConfig';
import { Http, Response, RequestOptions, HttpModule, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';

@Injectable()
export class ParComplaintsDocumentsService {
  url = environment.configURI;
  load;
  private deleteComplaintDocumentData = '/complaints/documents/';

  constructor(private httpClient: HttpClient, private http: Http, private userFriendlyMsgs: UserFriendlyMsgs) {
    this.load = new BehaviorSubject('initial');
  }

  /***
   * Post API to create a new document
   * @param data
   * @returns {Observable<R|T>}
   */
  addDocument(data){
      return this.httpClient.post(this.url + '/complaints/documents', data)
        .catch(this.userFriendlyMsgs.errorHandler);
  }

  /***
   * Get API to get list of documents
   * @param complaintId
   * @returns {Observable<R|T>}
   */
  getDocuments(complaintId){
    return this.httpClient.get(this.url + '/complaints_view_documents/'+complaintId)
      .catch(this.userFriendlyMsgs.errorHandler);
  }

  /***
   * Delete API to delete a given Complaint
   * @param id
   * @param complaintId
   * @returns {Observable<R|T>}
   */
  deleteComplaintsDocuments(id, complaintId) {
    return this.httpClient.delete(`${this.url}${this.deleteComplaintDocumentData}${id}` + '/' + `${complaintId}`).catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/par-complaints-documents/par-complaints-documents.service.ts